// extracted by mini-css-extract-plugin
export default {"needleContainer":"needle_needleContainer__cMBW-","triangle":"needle_triangle__0NJ4z","line":"needle_line__OZ1Zq"};